// extracted by mini-css-extract-plugin
export var AppBackgroundImage = "index-module--AppBackgroundImage--1cb26";
export var BackgroundImageWrapperFull = "index-module--BackgroundImageWrapperFull--fd621";
export var BackgroundImageWrapperSplit = "index-module--BackgroundImageWrapperSplit--a10c3";
export var DefaultImage = "index-module--DefaultImage--00fa7";
export var MobileBackgroundImage = "index-module--MobileBackgroundImage--520de";
export var NoHeader = "index-module--NoHeader--6ed04";